import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../api';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    if (!email) { setError('Please enter your email address.'); return; }
    setLoading(true); setError('');
    try {
      await api.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch {
      // Even on error show the success state — don't expose internals
      setSubmitted(true);
    } finally { setLoading(false); }
  }

  const containerStyle = {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #1a2535 0%, #1a3a5c 100%)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
  };
  const cardStyle = {
    background: '#fff', borderRadius: 16, padding: 36, width: '100%', maxWidth: 420,
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  };
  const inputStyle = {
    width: '100%', padding: '11px 14px', fontSize: 14, borderRadius: 8,
    border: '1px solid #d0d7de', outline: 'none', boxSizing: 'border-box',
  };
  const btnStyle = {
    width: '100%', padding: 13, background: loading ? '#93c5fd' : '#1a2535',
    color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700,
    cursor: loading ? 'not-allowed' : 'pointer', marginTop: 6, transition: 'background 0.15s',
  };

  return (
    <div style={containerStyle}>
      <div style={{ width: '100%', maxWidth: 420 }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <img src="/jobhub-logo-dark.png" alt="JobHub" style={{ height: 100, width: 'auto', objectFit: 'contain', marginBottom: 8 }} />
          <p style={{ color: '#7aa3c0', fontSize: 14, margin: 0 }}>Job costing for electrical contractors</p>
        </div>

        <div style={cardStyle}>
          {!submitted ? (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontSize: 20, fontWeight: 800, color: '#111827', margin: '0 0 6px' }}>Forgot your password?</h2>
                <p style={{ fontSize: 14, color: '#6b7280', margin: 0, lineHeight: 1.5 }}>
                  Enter your account email and we'll send you a link to reset your password.
                </p>
              </div>

              {error && (
                <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 8, padding: '10px 14px', color: '#dc2626', fontSize: 13, marginBottom: 16 }}>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ fontSize: 13, fontWeight: 600, color: '#374151', display: 'block', marginBottom: 5 }}>
                    Email address
                  </label>
                  <input
                    style={inputStyle}
                    type="email"
                    placeholder="admin@yourcompany.com"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    autoFocus
                    required
                  />
                </div>
                <button type="submit" style={btnStyle} disabled={loading}>
                  {loading ? 'Sending...' : 'Send reset link'}
                </button>
              </form>

              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <Link to="/login" style={{ fontSize: 13, color: '#6b7280', textDecoration: 'none' }}>
                  ← Back to sign in
                </Link>
              </div>
            </>
          ) : (
            /* Success state */
            <div style={{ textAlign: 'center', padding: '8px 0' }}>
              <div style={{ width: 60, height: 60, background: '#dcfce7', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, margin: '0 auto 20px' }}>
                ✉️
              </div>
              <h2 style={{ fontSize: 20, fontWeight: 800, color: '#111827', margin: '0 0 10px' }}>Check your email</h2>
              <p style={{ fontSize: 14, color: '#6b7280', lineHeight: 1.6, margin: '0 0 8px' }}>
                If <strong>{email}</strong> is associated with a Jobhub account, you'll receive a password reset link shortly.
              </p>
              <p style={{ fontSize: 13, color: '#9ca3af', lineHeight: 1.5, margin: '0 0 24px' }}>
                The link expires in 1 hour. Check your spam folder if you don't see it.
              </p>

              <div style={{ background: '#f9fafb', borderRadius: 8, padding: '12px 16px', marginBottom: 24, textAlign: 'left', fontSize: 13, color: '#6b7280' }}>
                <div style={{ fontWeight: 600, color: '#374151', marginBottom: 6 }}>Didn't get the email?</div>
                <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.8 }}>
                  <li>Check your spam / junk folder</li>
                  <li>Make sure you used the right email</li>
                  <li><button onClick={() => setSubmitted(false)} style={{ background: 'none', border: 'none', color: '#1d4ed8', cursor: 'pointer', padding: 0, fontSize: 13 }}>Try again with a different email</button></li>
                </ul>
              </div>

              <Link to="/login" style={{ display: 'block', padding: '11px', background: '#1a2535', color: '#fff', borderRadius: 8, textDecoration: 'none', fontSize: 14, fontWeight: 600, textAlign: 'center' }}>
                Back to sign in
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
